import { FC } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { DailyReportFormModel } from '../../models';
import { FilterForm } from './FilterForm';

type FilterFormProviderProps = {
  form: UseFormReturn<DailyReportFormModel, any, undefined>;
  onSubmit: (data: DailyReportFormModel) => void;
  onSave: (data: DailyReportFormModel) => void;
  onSaveAndExport: (data: DailyReportFormModel) => void;
  isSaving?: boolean;
  isExporting?: boolean;
  defaultValues: DailyReportFormModel;
};

export const FilterFormProvider: FC<FilterFormProviderProps> = ({
  form,
  onSubmit,
  onSave,
  onSaveAndExport,
  isSaving,
  isExporting,
  defaultValues,
}) => {
  return (
    <FormProvider {...form}>
      <FilterForm
        onSubmit={onSubmit}
        onSave={onSave}
        onSaveAndExport={onSaveAndExport}
        isSaving={isSaving}
        isExporting={isExporting}
        reset={() => form.reset(defaultValues)}
      />
    </FormProvider>
  );
};
